import { createFileRoute, redirect } from '@tanstack/react-router';

/** The jobs page's old address. */
export const Route = createFileRoute('/_app/dashboard')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/jobs', replace: true });
  },
});
